export default "__VITE_ASSET__BGqWvMAp__"